import { Route } from '@angular/router';
import { authGuard, loggedOutGuard, VerifyPasswordGuard } from '@program-suite/data-auth';
import { LoggedInComponent, LoggedOutComponent } from '@program-suite/ui';
import { AgencyGridComponent } from '@program-suite/feature-agencies-grid';
import { SubmissionGridComponent } from '@program-suite/feature-submission-grid';
import { PolicyGridComponent } from '@program-suite/feature-policy-grid';
import { ViewSubmissionComponent } from '@program-suite/feature-view-submission';
import { DashboardComponent } from '@program-suite/feature-dashboard';
import { FeaturePolicyFormsGridComponent } from '@program-suite/feature-policy-forms-grid';
import { ProgramGuidelinesComponent } from '@program-suite/feature-program-guidelines';
import { ProgramGuidelinesDetailsComponent } from '@program-suite/feature-program-guidelines';
import { UserProfileComponent } from '@program-suite/feature-user-profile';
import { AdditionalInsuredFormComponent, CoverageAdjustmentFormComponent } from '@program-suite/feature-policy-endorsements';

export const appRoutes: Route[] = [
  {
    path: 'authentication',
    component: LoggedOutComponent,
    canActivate: [loggedOutGuard],
    children: [
      {
        path: 'login',
        loadComponent: () => import('@program-suite/ui-login').then((m) => m.LoginComponent),
      },
      {
        path: 'forgot-password',
        loadComponent: () => import('@program-suite/ui-forgot-password').then((m) => m.ForgotPasswordComponent),
      },
      {
        path: 'verify',
        // canActivate: [VerifyPasswordGuard],
        loadComponent: () => import('@program-suite/ui-verify-password').then((m) => m.VerifyPasswordComponent),
      },
      {
        path: 'reset',
        canActivate: [VerifyPasswordGuard],
        loadComponent: () => import('@program-suite/ui-reset-password').then((m) => m.ResetPasswordComponent),
      },
      {
        path: 'register/:role',
        loadComponent: () => import('@program-suite/feature-register').then((m) => m.RegisterComponent),
      }
    ]
  },
  {
    path: '',
    canActivate: [authGuard()],
    component: LoggedInComponent,
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'quote/:id',
        loadComponent: () => import('@program-suite/feature-quoting').then((m) => m.QuoteWizardComponent),
      },
      {
        path: 'lio-quote/:id',
        loadComponent: () => import('@program-suite/feature-lio-quoting').then((m) => m.LioWizardComponent),
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
      },
      {
        path: 'submissions',
        component: SubmissionGridComponent,
      },
      {
        path: 'agencies',
        component: AgencyGridComponent,
      },
      {
        path: 'submissions/:tab/:id',
        component: ViewSubmissionComponent,
      },
      {
        path: 'policies',
        component: PolicyGridComponent,
      },
      {
        path: 'policies/:tab/:id',
        component: ViewSubmissionComponent,
      },
      {
        path: 'policies/:tab/:id/additional-insured/:id',
        component: AdditionalInsuredFormComponent,
      },
      {
        path: 'policies/:tab/:id/coverage-adjustment/:id',
        component: CoverageAdjustmentFormComponent,
      },
      {
        path: 'program-guidelines',
        component: ProgramGuidelinesComponent,
      },
      {
        path: 'program-guidelines/:id',
        component: ProgramGuidelinesDetailsComponent,
      },
      {
        path: 'policy-forms',
        component: FeaturePolicyFormsGridComponent,
      },
      // {
      //   path: 'resources',
      //   component: TempCompComponent,
      // },
      {
        path: 'profile',
        component: UserProfileComponent,
      },
      {
        path: 'wholesale-settings',
        canActivate: [authGuard({requiredRoles: ['Wholesale Admin'], redirectTo: '/dashboard'})],
        loadComponent: () => import('@program-suite/feature-admin-settings').then((m) => m.AdminSettingsComponent),
      },
      {
        path: 'wholesale-settings/:tab',
        canActivate: [authGuard({requiredRoles: ['Wholesale Admin'], redirectTo: '/dashboard'})],
        loadComponent: () => import('@program-suite/feature-admin-settings').then((m) => m.AdminSettingsComponent),
      },
      {
        path: 'agency',
        canActivate: [authGuard({requiredRoles: ['Wholesale Admin'], redirectTo: '/dashboard'})],
        loadComponent: () => import('@program-suite/feature-agency-users').then((m) => m.AgencyUsersComponent),
      },
      {
        path: 'agency/:tab',
        canActivate: [authGuard({requiredRoles: ['Wholesale Admin'], redirectTo: '/dashboard'})],
        loadComponent: () => import('@program-suite/feature-agency-users').then((m) => m.AgencyUsersComponent),
      },
      {
        path: 'agents',
        canActivate: [authGuard({requiredRoles: ['Wholesale Admin', 'Wholesale Manager'], redirectTo: '/dashboard'})],
        loadComponent: () => import('@program-suite/feature-all-users').then((m) => m.FeatureAllUsersComponent),
      },
    ],
  },
  {
    path: 'login',
    redirectTo: 'authentication/login',
  },
  {
    path: 'register/:role',
    redirectTo: 'authentication/register/:role',
  }
];
